import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class plantIdRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    brandId?: number;
   
}